export default function About() {
  return (
    <div className="about-container">
      <img className="about-avatar" src="deivi.png" alt="stylized avatar pic" />
      <p className="about-text">
        I'm David, a media engineer from Germany. I currently live in
        Benalmádena on the spanish Costa del Sol. I worked for every major
        tv-station in Germany and i'm still remote working for two public
        broadcasters. So i guess i'm somewhat a digital nomad 😉
      </p>
      <p className="about-text">
        My experiences include video production, content development, live tv
        production and editing. I wrote and directed three documentaries on
        contemporary art and remixing. 5 years ago i rediscovered my fascination
        for programming and web development. I bootcamped in Responsive Web
        Design, React, Vue and Svelte and developed dozens of applications for
        training purposes.
      </p>
      <p className="about-text">
        The <strong>Crypto Dashboard</strong> is part of my professional
        portfolio. The prompt for this project came from{" "}
        <strong>#50 React Projects</strong> by Colby Fayock and i will continue
        my journey with more projects from that resource. At least until i find
        something better to do ...
      </p>
    </div>
  );
}
